/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Data_Loading_Failed_ContentInputs */

const en_dialog_data_loading_failed_content = /** @type {(inputs: Dialog_Data_Loading_Failed_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please change your network and try again. If the issue persists, please return to the app to contact customer service.`)
};

const ar_dialog_data_loading_failed_content = /** @type {(inputs: Dialog_Data_Loading_Failed_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`يرجى تغيير الشبكة والمحاولة مرة أخرى. إذا استمرت المشكلة، يرجى العودة إلى التطبيق للتواصل مع خدمة العملاء.`)
};

const de_dialog_data_loading_failed_content = /** @type {(inputs: Dialog_Data_Loading_Failed_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitte wechseln Sie Ihr Netzwerk und versuchen Sie es erneut. Wenn das Problem weiterhin besteht, kehren Sie bitte zur App zurück und kontaktieren Sie den Kundendienst.`)
};

const es_dialog_data_loading_failed_content = /** @type {(inputs: Dialog_Data_Loading_Failed_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cambia de red e inténtalo de nuevo. Si el problema persiste, vuelve a la app para contactar con atención al cliente.`)
};

const fr_dialog_data_loading_failed_content = /** @type {(inputs: Dialog_Data_Loading_Failed_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veuillez changer de réseau et réessayez. Si le problème persiste, veuillez contacter le service client via l'application.`)
};

const it_dialog_data_loading_failed_content = /** @type {(inputs: Dialog_Data_Loading_Failed_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cambia la tua rete e riprova. Se il problema persiste, torna all'app per contattare il servizio clienti.`)
};

const ja_dialog_data_loading_failed_content = /** @type {(inputs: Dialog_Data_Loading_Failed_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ネットワークを変更して再度お試しください。問題が解決しない場合は、アプリに戻ってカスタマーサービスにご連絡ください。`)
};

const ko_dialog_data_loading_failed_content = /** @type {(inputs: Dialog_Data_Loading_Failed_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`네트워크를 변경하고 다시 시도해 보세요. 문제가 지속되면 앱으로 돌아가 고객센터로 문의하세요.`)
};

const pt_br_dialog_data_loading_failed_content = /** @type {(inputs: Dialog_Data_Loading_Failed_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Troque de rede e tente novamente. Se o problema persistir, retorne ao aplicativo e contate o atendimento ao cliente.`)
};

const ru_dialog_data_loading_failed_content = /** @type {(inputs: Dialog_Data_Loading_Failed_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Смените сеть и повторите попытку. Если проблема не исчезнет, вернитесь в приложение, чтобы связаться со службой поддержки клиентов.`)
};

const th_dialog_data_loading_failed_content = /** @type {(inputs: Dialog_Data_Loading_Failed_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`โปรดเปลี่ยนเครือข่ายแล้วลองอีกครั้ง หากปัญหายังอยู่ โปรดกลับไปที่แอปเพื่อติดต่อฝ่ายบริการลูกค้า`)
};

const tr_dialog_data_loading_failed_content = /** @type {(inputs: Dialog_Data_Loading_Failed_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lütfen ağını değiştirip tekrar dene. Sorun devam ederse lütfen müşteri hizmetleriyle iletişime geçmek için uygulamaya geri dön.`)
};

const zh_cn_dialog_data_loading_failed_content = /** @type {(inputs: Dialog_Data_Loading_Failed_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`请检查网络并再试一次。若问题持续发生，请回到 App 联系客服`)
};

const zh_tw_dialog_data_loading_failed_content = /** @type {(inputs: Dialog_Data_Loading_Failed_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`請檢查網路並再試一次。若問題持續發生，請回到 App 聯繫客服`)
};

/**
* | output |
* | --- |
* | "Please change your network and try again. If the issue persists, please return to the app to contact customer service." |
*
* @param {Dialog_Data_Loading_Failed_ContentInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const dialog_data_loading_failed_content = /** @type {((inputs?: Dialog_Data_Loading_Failed_ContentInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Data_Loading_Failed_ContentInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dialog_data_loading_failed_content(inputs)
	if (locale === "ar") return ar_dialog_data_loading_failed_content(inputs)
	if (locale === "de") return de_dialog_data_loading_failed_content(inputs)
	if (locale === "es") return es_dialog_data_loading_failed_content(inputs)
	if (locale === "fr") return fr_dialog_data_loading_failed_content(inputs)
	if (locale === "it") return it_dialog_data_loading_failed_content(inputs)
	if (locale === "ja") return ja_dialog_data_loading_failed_content(inputs)
	if (locale === "ko") return ko_dialog_data_loading_failed_content(inputs)
	if (locale === "pt_br") return pt_br_dialog_data_loading_failed_content(inputs)
	if (locale === "ru") return ru_dialog_data_loading_failed_content(inputs)
	if (locale === "th") return th_dialog_data_loading_failed_content(inputs)
	if (locale === "tr") return tr_dialog_data_loading_failed_content(inputs)
	if (locale === "zh_cn") return zh_cn_dialog_data_loading_failed_content(inputs)
	return zh_tw_dialog_data_loading_failed_content(inputs)
});